import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { importTaskQueryKeys } from '@front/hook/Api/ImportTask/queryKeys';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition';
import type { IImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { importTableDefinitionQueryKeys } from './queryKeys';

const repository = new ImportTableDefinitionRepository();

export const _delete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: IImportTableDefinitionRepository.Remove.Params) => {
      return repository.remove(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    onSuccess: (_data, variables) => {
      queryClient.removeQueries({
        queryKey: importTableDefinitionQueryKeys.detail(variables.projectId, variables.id),
      });
      void queryClient.invalidateQueries({
        queryKey: importTableDefinitionQueryKeys.listPrefix(variables.projectId),
      });
      void queryClient.invalidateQueries({
        queryKey: importTaskQueryKeys.listPrefix(variables.projectId),
      });
    },
    ...UseMutationDefaultOptions,
  });
};
